<template>
    <div v-if="!loading">
        <div class="col-4 ml-auto p-0">
            <b-form-group class="">
                <b-input-group>
                    <b-form-input
                        v-model="filter"
                        placeholder="Entrer la valeur recherchée"
                    />
                    <b-input-group-append>
                        <b-button :disabled="!filter" @click="resetSearch">
                            Effacer
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </div>
        <b-table
            responsive
            :fields="fields"
            :items="items"
            :filter="filter"
            :filter-included-fields="['search']"
            :per-page="perPage"
            :current-page="currentPage"
            @filtered="onFiltered"
        >
            <template #cell(is_cador_linked)="data">
                <div :key="'link' + data.item.id">
                    <i
                        v-if="data.item.is_cador_linked"
                        class="fas fa-check-circle fa-lg text-success"
                    ></i>
                    <i v-else class="fas fa-times-circle fa-lg text-danger"></i>
                </div>
            </template>

            <template #cell(current)="data">
                <clients-cador-table-item
                    :key="'y1' + data.item.id"
                    :is-current="true"
                    :client-id="data.item.id"
                    :is-cador-linked="data.item.is_cador_linked === 1"
                    :exercice="data.item.current"
                    @client-updated="getData"
                />
            </template>
            <template #cell(exercice_1)="data">
                <clients-cador-table-item
                    :key="'y2' + data.item.id"
                    :is-current="false"
                    :client-id="data.item.id"
                    :is-cador-linked="data.item.is_cador_linked === 1"
                    :exercice="data.item.exercice_1"
                    @client-updated="getData"
                />
            </template>

            <template #cell(exercice_2)="data">
                <clients-cador-table-item
                    :key="'y3' + data.item.id"
                    :is-current="false"
                    :client-id="data.item.id"
                    :is-cador-linked="data.item.is_cador_linked === 1"
                    :exercice="data.item.exercice_2"
                    @client-updated="getData"
                />
            </template>

            <template #cell(exercice_3)="data">
                <clients-cador-table-item
                    :key="'y4' + data.item.id"
                    :is-current="false"
                    :client-id="data.item.id"
                    :is-cador-linked="data.item.is_cador_linked === 1"
                    :exercice="data.item.exercice_3"
                    @client-updated="getData"
                />
            </template>
        </b-table>

        <b-row>
            <b-col md="3" class="my-1 text-center">
                <b-pagination
                    v-if="totalRows > 0"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    class="my-0"
                    size="sm"
                ></b-pagination>
            </b-col>
            <b-col md="6" class="my-2">
                <p class="text-center small pt-0">{{ legend }}</p>
            </b-col>
            <b-col md="3" class="my-1 text-right">
                <b-dropdown
                    right
                    split
                    size="sm"
                    :text="perPage + ' éléments par page'"
                >
                    <b-dropdown-item
                        v-for="pageOption in pageOptions"
                        :key="pageOption"
                        @click="setPerPage(pageOption)"
                    >
                        {{ pageOption }}
                    </b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>
    </div>
    <div v-else>
        <loading />
    </div>
</template>

<script>
import ToastHandler from '../../../common/mixins/ToastHandler.vue'
import ClientsCadorTableItem from '../components/clients/ClientsCadorTableItem.vue'
import TableHandler from '../../../common/mixins/TableHandler.vue'

export default {
    name: 'TableCadorClients',
    components: { ClientsCadorTableItem },

    mixins: [ToastHandler, TableHandler],

    data() {
        return {
            loading: false,
            fields: [],
        }
    },

    async created() {
        this.loading = true
        await this.getTableFields()
        await this.getData()
        this.loading = false
    },

    methods: {
        async getData() {
            try {
                const response = await this.$axios.get('/cador/client')
                this.items = response.data.data
                this.filteredItems = this.items
                this.updateTotalRows()
            } catch (e) {
                this.showErrorToast(e)
            }
        },
        async getTableFields() {
            try {
                const response = await this.$axios.get(
                    '/cador/client/tableFields'
                )
                this.fields = response.data
            } catch (e) {
                // this.showErrorToast(e)
            }
        },

        async fetchCadorData(clientId, exercice) {
            try {
                await this.$axios.get(
                    `/cador/client/${clientId}/${exercice}/update`
                )
            } catch (e) {
                this.showErrorToast(e)
            }
        },
    },
}
</script>

<style scoped></style>
